import { CaretLeftFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { NavigateOptions, useNavigate } from "react-router-dom";

import { colours } from "../../styles/colours";
import style from "./GoBackButton.module.scss";

export interface IGoBackButtonProps {
  routePath?: string;
  beforeNavigate?: () => void;
  options?: NavigateOptions;
}

export const GoBackButton = ({
  routePath,
  options,
  beforeNavigate,
}: IGoBackButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    beforeNavigate && beforeNavigate();
    routePath && navigate(routePath, options);
  };

  return (
    <div className={style.goBackBtn} onClick={handleGoBack}>
      <CaretLeftFilled style={{ color: colours.primaryDefault }} />{" "}
      <span style={{ color: colours.primaryDefault }}>{t("COMMON.NAZAD")}</span>
    </div>
  );
};
